/**
 * For a press-and-hold that opens something (a menu, a sheet) while the finger or mouse
 * button is still down: when it lifts, that release must not also "tap" whatever is now under
 * it (a menu row, the sheet's backdrop — which would close it). Listens on the window, since
 * the pressed element may be covered or gone by then.
 *
 * `refocus`: put the caret back in the opened sheet's first box inside the release — phones
 * only raise the keyboard for focus that happens during a touch.
 */
export function guardHoldRelease(opts: { onRelease?: () => void; refocus?: boolean } = {}) {
  const onEnd = (e: Event) => {
    window.removeEventListener('touchend', onEnd, true)
    window.removeEventListener('mouseup', onEnd, true)
    opts.onRelease?.()
    if (e.type === 'touchend' && e.cancelable) e.preventDefault()
    if (opts.refocus) {
      const input = document.querySelector<HTMLInputElement>('.sheet input')
      if (input) {
        input.blur()
        input.focus()
      }
    }
    const swallow = (ev: MouseEvent) => {
      ev.preventDefault()
      ev.stopPropagation()
      window.removeEventListener('click', swallow, true)
    }
    window.addEventListener('click', swallow, true)
    setTimeout(() => window.removeEventListener('click', swallow, true), 400)
  }
  window.addEventListener('touchend', onEnd, { capture: true, passive: false })
  window.addEventListener('mouseup', onEnd, true)
}
